import httpClient from "../api/httpClient";

export const getPackages = async () => {
  const endpoint = "/Packages";
  return httpClient.get(endpoint);
};

export const addPerson = async (payload) => {
  const endpoint = "/refdeceaseds/createperson";
  return httpClient.post(endpoint, payload);
};

export const addPet = async (payload) => {
  const endpoint = "/refdeceaseds/createpet";
  return httpClient.post(endpoint, payload);
};

export const followPerson = async (payload) => {
  const endpoint = "/reffollowinginvitation/create";
  return httpClient.post(endpoint, payload);
};

export const getPerson = async (payload) => {
  const endpoint = `refdeceaseds/getById?id=${payload.personId}&IsHuman=${payload.isHuman}`;
  return httpClient.get(endpoint);
};

export const getAllPersons = async (payload) => {
  const endpoint = `refdeceaseds/getmany?Limit=${payload.limit}&PageNumber=${
    payload.pageIndex
  }&IsHuman=${payload.isHuman}&FirstName=${payload.name ||
    ""}&LastName=${payload.surname || ""}`;
  return httpClient.get(endpoint);
};

export const updatePerson = async (payload) => {
  const endpoint = `/refdeceaseds/updatedeceasedperson`
  return httpClient.put(endpoint, payload);
};

export const updatePet = async (payload) => {
  const endpoint = `/refdeceaseds/updatedeceasedpet`
  return httpClient.put(endpoint, payload);
};

export const getFollowers = async (payload) => {
  const endpoint = `/refdeceaseds/getFollowersByDeceasedId?id=${payload}`;
  return httpClient.get(endpoint);
};

export const getParsonMetrics = async (payload) => {
  const endpoint = `/refdeceaseds/deceasedmetrics?deceasedId=${payload}`;
  return httpClient.get(endpoint);
};

export const getMedia = async (payload) => {
  const endpoint = `refdeceaseds/${payload}/getMedia`;
  return httpClient.get(endpoint);
};


export default {
  getMedia,
  getPackages,
  addPerson,
  addPet,
  getPerson,
  getAllPersons,
  followPerson,
  updatePerson,
  updatePet,
  getFollowers,
  getParsonMetrics
};
